var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['submit-button'],on:{"click":function($event){$event.preventDefault();return _vm.$emit('submit')}}},[(_vm.submitting)?_c('LoadingSpinner',{key:"loading-spinner",attrs:{"color":"#fff"}}):_c('span',[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }